export default {
  /**
   * Returns the list of all aggregations
   */
  getAggregations: state => {
    return state.aggregations
      ? state.aggregations.map(item => ({
          id: item,
          name: item,
        }))
      : null;
  },

  /**
   * Returns the list of all comparisons
   */
  getComparisons: state => {
    return state.comparisons
      ? state.comparisons.map(item => ({
          id: item,
          name: item,
        }))
      : null;
  },
  /**
   * Returns the list of all operations
   */
  getOperations: state => {
    return state.operations
      ? state.operations.map(item => ({
          id: item,
          name: item,
        }))
      : null;
  },
};
